/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'caocao-1': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操（單身東歸）', w: 1 },
      { f: 'dz', n: '董卓', l: '關上守兵、中牟亭長' },
    ],
    before: '中平六年，董卓帶兵進洛陽，廢少帝、立獻帝，把持朝政。董卓上表讓曹操當驍騎校尉，想拉他一起共事。曹操不肯，改名換姓，從小路逃出洛陽往東走。',
    after: '過中牟時被亭長起疑、押到縣裡，縣裡有人暗中認出他，替他說情才放走。曹操到陳留散盡家財、招募義兵，這年十二月在己吾起兵，準備討伐董卓。',
    src: '《三國志·魏書·武帝紀》',
  },
  'caocao-2': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、曹洪、衛茲' },
      { f: 'dz', n: '董卓', l: '徐榮', w: 1 },
    ],
    before: '初平元年，關東各州郡起兵討董卓，推袁紹為盟主，曹操代理奮武將軍。董卓燒了洛陽、挾天子西遷長安。諸侯各自屯兵觀望，不肯進軍，曹操只好自己帶兵西進，想先占成皋。',
    after: '曹操在滎陽汴水遇徐榮，兵敗中箭，戰馬受傷，靠曹洪讓馬才趁夜逃走。徐榮見曹軍兵少卻力戰了一整天，認為酸棗不好打，也收兵回去。曹操回到酸棗，看諸軍十餘萬人天天置酒高會，便和夏侯惇等人到揚州另外募兵。',
    src: '《三國志·魏書·武帝紀》；〈曹洪傳〉',
  },
  'caocao-3': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、鮑信', w: 1 },
      { f: 'hj', n: '青州黃巾', l: '黃巾百萬眾' },
    ],
    before: '初平三年，青州黃巾百萬人湧進兗州，殺了任城相鄭遂，兗州刺史劉岱出戰也被殺。鮑信等人迎曹操來當兗州牧。曹操在壽張東邊和黃巾交戰，鮑信戰死。',
    after: '曹操一路追到濟北，黃巾乞降。冬天收降卒三十多萬、男女一百多萬口，挑出其中精銳編成「青州兵」，成了曹操起家的主力。',
    src: '《三國志·魏書·武帝紀》',
  },
  'caocao-4a': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、典韋、樓異' },
      { f: 'lb', n: '呂布', l: '呂布、陳宮、張邈' },
    ],
    before: '興平元年，曹操第二次東征徐州陶謙。陳宮、張邈趁機迎呂布進兗州，郡縣紛紛響應，只剩鄄城、范、東阿三城沒動。曹操回師，呂布攻鄄城不下，往西屯在濮陽。',
    after: '曹操夜襲濮陽西邊的別屯，天亮前攻破，卻被呂布救兵三面圍住，靠典韋帶應募的死士衝陣才撐到日暮撤走，典韋因此拜都尉。之後攻濮陽城，青州兵被呂布騎兵衝散，曹操衝出火場時墜馬、燒傷左手掌，司馬樓異扶他上馬才逃回（《獻帝春秋》裴注說是城中田氏詐降誘他入城）。兩軍相持一百多天，遇上蝗災、雙方都缺糧，各自退兵。',
    src: '《三國志·魏書·武帝紀》《典韋傳》；《武帝紀》注引《獻帝春秋》',
  },
  'caocao-5': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、典韋、曹昂、曹安民' },
      { f: 'xl', n: '張繡', l: '張繡、賈詡', w: 1 },
    ],
    before: '建安二年正月，曹操南征到宛城，張繡率眾投降。曹操納了張繡叔叔張濟的遺孀，張繡懷恨；曹操聽說他不滿，暗中打算殺他，消息走漏，張繡搶先夜襲曹營。',
    after: '曹操中了流箭，長子曹昂、姪子曹安民戰死，典韋守營門力戰而死。《世語》（裴注）說曹昂不會騎馬，把馬讓給曹操，曹操才逃脫。曹操退到舞陰，擊退追來的張繡騎兵，張繡逃到穰城和劉表聯合。',
    src: '《三國志·魏書·武帝紀》《典韋傳》《張繡傳》；《武帝紀》注引《魏書》《世語》',
  },
  'caocao-6': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、荀攸、郭嘉', w: 1 },
      { f: 'shu', n: '劉備', l: '劉備（助曹操圍城）', w: 1 },
      { f: 'lb', n: '呂布', l: '呂布、陳宮、高順' },
    ],
    before: '建安三年，呂布又和袁術聯手，派高順打敗劉備。九月曹操親自東征，攻破彭城，在下邳城外大破呂布的騎兵。呂布一度想投降，被陳宮勸住，退回城中固守。曹軍連戰疲憊，曹操本想撤兵。',
    after: '曹操用荀攸、郭嘉的計策，掘開泗水、沂水灌城。過了一個多月，呂布部將宋憲、魏續綁了陳宮開城投降，呂布、陳宮都被處死。張遼帶部眾歸降曹操，徐州落入曹操手中。',
    src: '《三國志·魏書·武帝紀》《呂布傳》《張遼傳》；〈蜀書·先主傳〉',
  },
  'caocao-7': {
    sides: [
      { f: 'wei', n: '曹操', l: '張遼、關羽、荀攸', w: 1 },
      { f: 'ys', n: '袁紹', l: '顏良、文醜、劉備' },
    ],
    before: '建安五年，袁紹滅了公孫瓚，帶大軍南下黎陽，派顏良圍攻白馬。荀攸獻計聲東擊西：曹操先假裝要從延津渡河襲擊袁紹後方，引開袁紹主力，再急行軍救白馬。關羽在徐州被擒後，這時暫在曹營。',
    after: '關羽在萬軍之中刺死顏良，白馬解圍；曹操把百姓遷走，沿黃河往西撤。在延津，曹操以輜重當誘餌，騎兵不到六百就大破袁軍，斬了文醜。關羽拜漢壽亭侯，之後封還賞賜，辭別曹操回到劉備身邊。',
    src: '《三國志·魏書·武帝紀》《荀攸傳》；〈蜀書·關羽傳〉',
  },
  'caocao-8': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、許攸、曹洪（守營）', w: 1 },
      { f: 'ys', n: '袁紹', l: '淳于瓊、張郃、高覽' },
    ],
    before: '官渡相持幾個月，曹軍糧食快吃完，曹操寫信給荀彧想退兵，荀彧勸他堅持。袁紹派淳于瓊帶一萬多人護送糧車，屯在袁營北邊四十里的烏巢。袁紹的謀士許攸貪財，袁紹滿足不了他，便投奔曹操，勸曹操去襲擊烏巢。',
    after: '曹操留曹洪守營，親率步騎五千夜行，天亮時趕到烏巢，斬淳于瓊、燒光糧草。《曹瞞傳》（裴注）說他們一路打著袁軍的旗號。袁紹派去攻曹營的張郃、高覽聽說烏巢失守，轉而投降，袁軍全面崩潰，袁紹和袁譚丟下大軍渡河逃走。',
    src: '《三國志·魏書·武帝紀》《荀彧傳》；《武帝紀》注引《曹瞞傳》',
  },
  'caocao-9': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、張遼、田疇', w: 1 },
      { f: 'hj', n: '烏桓', l: '蹋頓（《三國志》作烏丸）' },
      { f: 'ys', n: '袁尚、袁熙', l: '袁尚、袁熙' },
    ],
    before: '官渡之後袁紹病死，兒子們內鬨，曹操逐一平定河北。袁尚、袁熙逃到烏桓，投靠蹋頓。建安十二年曹操北征，郭嘉主張輕兵急進。夏天大水、沿海道路不通，田疇帶路出盧龍塞，大軍在山谷裡開路五百多里，直指柳城。',
    after: '八月登白狼山，突然撞上烏桓大軍。曹操登高望見敵陣不整，派張遼為先鋒衝擊，烏桓大潰，蹋頓和名王以下被斬，胡人、漢人投降的有二十多萬口。袁尚、袁熙逃往遼東，被公孫康斬首送來。',
    src: '《三國志·魏書·武帝紀》《張遼傳》《田疇傳》《郭嘉傳》',
  },
  'caocao-10': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操' },
      { f: 'wu', n: '孫權', l: '周瑜、程普、黃蓋', w: 1 },
      { f: 'shu', n: '劉備', l: '劉備', w: 1 },
    ],
    before: '建安十三年，曹操南征荊州，劉表病死，兒子劉琮投降。劉備逃往夏口，和孫權結盟。曹操得了荊州水軍，順江東下，在赤壁和孫劉聯軍相遇；軍中已有疫病，初戰失利，退到江北。黃蓋詐降，用火船燒了曹軍的船隊。',
    after: '曹操燒掉剩下的船撤退，士卒又餓又病，死了一大半。《山陽公載記》（裴注）說曹軍從華容道徒步撤走，泥濘難行，派羸兵背草填路，被人馬踩踏陷在泥裡死了很多。曹操留曹仁守江陵後北還，劉備趁勢取得荊州江南各郡。',
    src: '《三國志·魏書·武帝紀》；〈吳書·吳主傳〉〈周瑜傳〉；《武帝紀》注引《山陽公載記》',
  },
  'caocao-11': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、許褚、丁斐', w: 1 },
      { f: 'xl', n: '馬超、韓遂', l: '馬超、韓遂、成宜、李堪' },
    ],
    before: '建安十六年，曹操派鍾繇征張魯，關中諸將懷疑是衝著自己來的，馬超、韓遂等人起兵反叛，屯在潼關。七月曹操親征，和馬超夾關對峙，暗中先派徐晃、朱靈從蒲阪津渡河，在河西立營。',
    after: '曹操從潼關北渡黃河時，留在南岸斷後，馬超帶步騎一萬多人殺來，箭如雨下，許褚扶曹操上船、舉馬鞍替他擋箭。校尉丁斐放出牛馬，敵兵爭搶，曹操才渡過去。之後曹操離間馬超、韓遂，九月渡渭水大破關西軍，馬超、韓遂逃回涼州。',
    src: '《三國志·魏書·武帝紀》《許褚傳》',
  },
  'caocao-12': {
    sides: [
      { f: 'shu', n: '劉備', l: '劉備、黃忠、法正', w: 1 },
      { f: 'wei', n: '曹操', l: '夏侯淵、張郃（後由曹操親至）' },
    ],
    before: '建安二十年曹操平定張魯、取得漢中，留夏侯淵鎮守。建安二十三年劉備進兵陽平關，雙方相持。隔年春天，劉備從陽平關南渡沔水，在定軍山扎營，夜裡燒了魏營的鹿角；夏侯淵自己帶輕兵去守南面。',
    after: '法正看準時機說「可擊矣」，黃忠從高處鼓譟衝下，夏侯淵戰死。三月曹操親自從長安出斜谷到漢中，劉備據險不戰，五月曹操撤回長安；《九州春秋》（裴注）記他當時出令「雞肋」。隔年正月，曹操死於洛陽，年六十六。',
    src: '《三國志·魏書·武帝紀》《夏侯淵傳》；〈蜀書·法正傳〉〈先主傳〉；《武帝紀》注引《九州春秋》',
  },
};
